<template lang="pug">
div
  em-loading(:active="loading" :is-full-page="false")
  .px-2(v-if="memberships && memberships.length" :class="{'box': !activeMemberships.length}")
    .has-border-bottom.mb-4(v-if="activeMemberships.length")
      customer-membership-view(:value="membership._id" v-for="membership in activeMemberships" :key="membership._id" @click="openDetails(membership)")
    .has-text-centered.pb-4.has-border-bottom(v-else) {{ $t('customer.no_active_memberships') }}
    .has-text-centered.mt-4
      a(@click="showAllMemberships()") {{ $t('customer.show_all_memberships') }}
  .box.p-4.has-text-centered(v-else) {{ $t('customer.no_memberships') }}
</template>
<script>
import MembershipDetails from './MembershipDetails.vue'
import CustomerAllMemberships from './CustomerAllMemberships.vue'
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'CustomerMembershipsList',
  props: {
    customerId: {type: String, required: true}
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('memberships', ['customerActiveMemberships', 'customerMemberships']),
    activeMemberships() {
      return this.customerActiveMemberships(this.customerId)
    },
    memberships() {
      return this.customerMemberships(this.customerId)
    }
  },

  async created() {
    this.init()
  },
  methods: {
    ...mapActions('memberships', ['fetchCustomerMemberships']),
    async init() {
      this.loading = true
      try {
        await this.fetchCustomerMemberships(this.customerId)
      } catch (error) {
        this.$handleAPIError(error)
      } finally {
        this.loading = false
      }
    },
    showAllMemberships() {
      this.$buefy.modal.open({
        parent: this,
        width: 640,
        hasModalCard: true,
        fullScreen: this.isMobile(),
        component: CustomerAllMemberships,
        canCancel: ['escape'],
        props: {
          customerId: this.customerId
        }
      })
    },
    openDetails(membership) {
      this.$buefy.modal.open({
        parent: this,
        width: 640,
        props: {value: membership._id},
        hasModalCard: true,
        fullScreen: this.isMobile(),
        component: MembershipDetails,
        canCancel: ['escape']
      })
    }
  }
}
</script>
